export class RecomDetails {
  id: number
  title: string
  text: string
  recommendationType: string
}